import { useCallback, useContext, useState } from 'react';
import { EditorContext } from '@/features/editor/context/editor-context';
import { AccountContext } from '@/features/account-context';

export function usePreviewDetails() {
  const { showAppEmbedModalIfNeeded } = useContext(AccountContext);
  const [previewPopoverOpen, setPreviewPopoverOpen] = useState(false);
  const {
    experienceState,
    deviceNavigation: { generateCheckoutUrlForPreview },
  } = useContext(EditorContext);

  const quickPreviewUrl =
    experienceState?.currentExperience?.quickPreviewUrl?.includes(`sdk.loomi`)
      ? generateCheckoutUrlForPreview()
      : experienceState?.currentExperience?.quickPreviewUrl;

  const togglePopover = useCallback(async () => {
    if (showAppEmbedModalIfNeeded()) {
      return;
    }
    setPreviewPopoverOpen(!previewPopoverOpen);
  }, [previewPopoverOpen]);

  return {
    quickPreviewUrl,
    togglePopover,
    previewPopoverOpen,
  };
}

export function usePreviewToggle() {
  const { experienceState, deviceNavigation } = useContext(EditorContext);

  let quickPreviewUrl = experienceState?.currentExperience?.quickPreviewUrl;
  if (
    deviceNavigation?.generateCheckoutUrlForPreview &&
    experienceState?.currentExperience?.quickPreviewUrl?.includes(`sdk.loomi`)
  ) {
    quickPreviewUrl = deviceNavigation?.generateCheckoutUrlForPreview();
  }

  const [previewPopoverOpen, setPreviewPopoverOpen] = useState(false);
  const togglePopover = useCallback(async () => {
    setPreviewPopoverOpen(!previewPopoverOpen);
  }, [previewPopoverOpen]);

  return {
    quickPreviewUrl,
    togglePopover,
    previewPopoverOpen,
  };
}
